import axios from 'axios'
import appConfig from "./config/appConfig.js";

let apiURL = process.env.BACKEND_API;
let API_URL = appConfig?.API_URL;
let CONFIG_URL = window?.appConfig?.TEST_ME;
console.log("API URL:",API_URL);

if(API_URL != apiURL){
    apiURL = API_URL;
}
//DEV LOCAL
  // apiURL = "http://localhost:8000/";


const instance = axios.create({
    baseURL: API_URL,
    headers: { 
        'Content-Type': 'application/json',
        //'Authorization': "Bearer " + localStorage.getItem("AuthToken"),
        }
});

// instance.interceptors.response.use(
//     (response) =>
//     new Promise((resolve, reject) => {
//         resolve(response);
//     }),
//     (error) => {
//         const originalRequest = error.config;
//         if (!error.response){
//             return new Promise(
//                 (resolve , reject) => {
//                     reject(error);
//                 });
//         }

//         if (error.response.status === 401 && !originalRequest._retry && localStorage.getItem("AuthToken") !== undefined){

//             originalRequest._retry = true;
//             console.log("original_request:",originalRequest);
//             if(!originalRequest.url.includes('/api/users/me')){
//                 // localStorage.removeItem("AuthToken");
//                 // window.location = "/admin/dashboard";
//             }

//         }
//         else{
//             return new Promise(
//                 (resolve , reject) => {
//                     reject(error);
//                 });
//         }

//     }
// )

export default instance
